module.exports = __webpack_public_path__ + "static/media/MKlogo.50233b7c.png";